import React, { FC, MouseEventHandler } from "react";
import {
  Button,
  Modal,
  Flex,
  ButtonKind,
  ButtonScale,
} from "@xometry/xometry_loft";
import { EmotionJSX } from "@emotion/react/types/jsx-namespace.d";

import { StyledModal, FormWrapper } from "./styles";

export type ModalProps = {
  selector?: string;
  isOpen: boolean;
  title?: string | EmotionJSX.Element;
  description?: string | EmotionJSX.Element;
  handleCloseButton?: MouseEventHandler;
  handleCancel?: MouseEventHandler;
  handleSubmit?: MouseEventHandler;
  submitActionText?: string | EmotionJSX.Element;
  submitButtonType?: ButtonKind;
  discardActionText?: string;
  cssStyle?: any;
  buttonScale?: ButtonScale;
};

const CommonModal: FC<ModalProps> = ({
  selector,
  isOpen,
  title,
  description,
  handleCloseButton,
  handleCancel,
  handleSubmit,
  submitActionText,
  submitButtonType,
  discardActionText,
  children,
  cssStyle,
  buttonScale,
}) => {
  return (
    <StyledModal isOpen={isOpen} selector={selector} css={cssStyle}>
      <div className="modal-title">
        <legend>{title}</legend>
        <Modal.CloseButton onClick={handleCloseButton} />
        <div className="modal-title__description">{description}</div>
      </div>
      <div className="modal-body">
        <FormWrapper>
          {children}
          <Flex justifyContent="flex-end">
            <Button scale={buttonScale} kind="text" onClick={handleCancel}>
              {discardActionText || "Cancel"}
            </Button>
            {submitActionText && (
              <Button
                className="submission-modal__submit-button"
                kind={submitButtonType || "primary"}
                scale={buttonScale}
                onClick={handleSubmit}
              >
                {submitActionText}
              </Button>
            )}
          </Flex>
        </FormWrapper>
      </div>
    </StyledModal>
  );
};

CommonModal.defaultProps = {
  submitButtonType: "primary",
  buttonScale: "large",
};

export default CommonModal;
